import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { useEffect } from "react";
import SearchCriteria from "./index/SearchCriteria";
import RecentList from "./index/RecentList";
import IndexingForm from "./index/IndexingForm";
import services from "../services/indexService";
import { taskPaneInitailValue, useTaskPane } from "../provider/TaskPaneProvider";
import useToast from "../hooks/useToast";
import { jwtDecode } from "jwt-decode";
import { SetAxiosDefauls } from "../services/authInterceptor";
import Loader from "./index/loader";
import axios from "axios";
import { appInsights, track, trackEvent, trackError, isVerboseTelemetry } from '../../telemetry/telemetryService';

const useStyles = makeStyles({
  root: {
    height: "100vh",
    overflowY: "auto",
  },
});

const MainContent = (props) => {
SetAxiosDefauls();
  const {
    setProfileDetails,
    taskPaneState,
    setTaskPaneState,
    profileDetails,
    setSelectedGridItem,
    setPoliciesDetailsForInsured,
    selectedItemDetailFromGrid,
    setCheckList,
    getLocationSpecificInfo,
    setUsername,
    username,
    loading,
    setLoading,
    checkList,
    selectedGridItem,
    setDocumentType,
    setDocumentClass,
    userGroups,
    user,
    queues
  } = useTaskPane();
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('dialog');
  const actionType = mode === "compose"? "sendMailAndOpenTaskPane": "openDialog";
  const { Toaster, notify, dismissAllToasts } = useToast();
  // const accessToken = sessionStorage.getItem('access-token');
  const [accessToken, setAccessToken] = React.useState(sessionStorage.getItem('access-token') || "");
  const [authToken, setAuthToken] = React.useState(sessionStorage.getItem('auth-token') || "");
  const [graphToken, setGraphToken] = React.useState(sessionStorage.getItem('graph_token') || "");
  const [authStatus, setAuthStatus] = React.useState("idle");
  const attemptedAuthName = React.useRef(null);
  const [profileStatus, setProfileStatus] = React.useState("idle");
  const [locationStatus] = React.useState("idle");
  // Set when running in a plain browser (no Office host) AND direct auth is forbidden (prod):
  // show an "open in Outlook" message instead of ever prompting for an email.
  const [directBlocked, setDirectBlocked] = React.useState(false);
  // Direct-auth (browser) only: when no email is known yet, render an in-app entry form.
  // office.js disables window.prompt ("Function window.prompt is not supported"), so a blocking
  // prompt crashes the task pane -- use a controlled input instead.
  const [emailNeeded, setEmailNeeded] = React.useState(false);
  const [emailInput, setEmailInput] = React.useState("");
  const getData = async () => {
    setProfileStatus("loading");
    setProfileDetails([]);
    sessionStorage.removeItem("userId");
    setTaskPaneState(prev => ({ ...prev, userId: "", profileUserGroupId: "", userGroupId: "", userGroup: "", comLocId: "", compLocId: "", compId: "" }));
    try {
      const result = await services.getUserProfileInfo(username);
      if (!Array.isArray(result) || result.length === 0) {
        setProfileDetails([]);
        sessionStorage.removeItem("userId");
        setProfileStatus("empty");
        return;
      }
        track("bootstrap.getData", { rowCount: result?.length ?? 0, userId: result?.[0]?.userID ?? null });
        setProfileDetails(result);
        setProfileStatus("success");
        sessionStorage.setItem('userId', result[0]?.userID);
        setTaskPaneState((prev) => ({ ...prev, userId: result[0]?.userID, profileUserGroupId: result[0]?.primaryUserGroupID, userGroupId: result[0]?.primaryUserGroupID, userGroup: result[0]?.userID }));
    } catch (e) {
      setProfileStatus("error");
      setTaskPaneState((prev) => ({
        ...prev,
        userId: "",
        profileUserGroupId: "",
        userGroupId: "",
        userGroup: "",
        comLocId: "",
        compLocId: "",
        compId: "",
      }));
      console.log(e);
      trackError(e, { seam: "bootstrap.getData" });
    }
  };

    const getAuthToken = async (name) => {
        attemptedAuthName.current = name;
        setAuthStatus("loading");
        try {
          const result = await services.getAuthToken(name);
          if (typeof result?.access_token !== "string" || !result.access_token.trim()) throw new Error("Missing auth token");
          sessionStorage.setItem("auth-token", result.access_token);
          localStorage.setItem("auth-token", result.access_token);
          setAuthToken(result.access_token);
          setUsername(name);
          setAuthStatus("success");
          // Email is dev data -> only attach the identity in non-prod; counts/flags everywhere.
          trackEvent("auth.getAuthToken.success", { hasToken: !!result.access_token, ...(isVerboseTelemetry ? { name } : {}) });
        } catch (e) {
          setAuthStatus("error");
          console.log(e);
          trackError(e, { seam: "auth.getAuthToken" });
        }
    };

    const getGraphToken = async (name, ssoToken) => {
        try {
            const result = await services.getGraphToken(name, ssoToken);
            sessionStorage.setItem("graph_token", result.graph_token);
            // Also localStorage: the compose/commands download path (fileDownload.js,
            // commands.js) runs in a separate window that shares localStorage, not sessionStorage.
            localStorage.setItem("graph_token", result.graph_token);
            setGraphToken(result.graph_token)
        } catch (e) {
            console.log(e);
        }
    };

    const retryBootstrap = (stage) => {
      if (stage === "auth") return getAuthToken(attemptedAuthName.current || username || localStorage.getItem("dev-user-email"));
      if (stage === "profile") return getData();
      return undefined;
    };

    useEffect(() => {
        // SSO seam: was an access-token (Office SSO) present when the taskpane mounted?
        trackEvent("sso.accessToken", { present: !!accessToken });
        if (accessToken) {
            try {
                const decoded = jwtDecode(accessToken);
                const preferredName =
                    decoded.preferred_username|| decoded?.unique_name || decoded.userPrincipalName || decoded.name || null;
                if (preferredName != null) {
                    getAuthToken(preferredName)
                    getGraphToken(preferredName, accessToken)
                    sessionStorage.setItem("fromAddress", preferredName)
                  }

            } catch (err) {
                console.error("Failed to decode token:", err);
                trackError(err, { seam: "sso.decodeAccessToken" });
            }
        }
    }, [accessToken]);

    // Auth-path selection by RUNTIME Office-host detection. Office.onReady resolves with
    // info.host = an Office.HostType (Outlook/Excel/Word) when hosted, and null/undefined when
    // the page is loaded in a plain browser (office.js is present but no host attaches).
    //   - host present  -> SSO path (the [accessToken] effect above); do nothing here.
    //   - host absent + direct PERMITTED (local or non-prod deploy, DIRECT_AUTH_ALLOWED) ->
    //       direct dev-auth: mint the app token directly and scope data by the dev's OWN
    //       identity (no SSO/consent). Resolve the email without a hardcoded person: build-time
    //       override (DEV_USER_EMAIL / public.js shared account), else a value this browser
    //       entered before, else prompt once and remember it. Mail/.eml still needs Outlook SSO.
    //   - host absent + direct FORBIDDEN (prod) -> show "open in Outlook"; NEVER prompt.
    // DIRECT_AUTH_ALLOWED is a build-time literal, so prod DCEs the direct branch entirely --
    // it cannot be re-enabled by tampering with a client value.
    useEffect(() => {
        Office.onReady((info) => {
            const host = info && info.host;
            // Diagnostic seam: which auth path the runtime chose (hosted Office host name vs browser).
            trackEvent("host.detection", { host: host ? String(host) : "browser", directAllowed: !!process.env.DIRECT_AUTH_ALLOWED });
            if (host) return; // hosted in Office -> SSO path
            if (!process.env.DIRECT_AUTH_ALLOWED) {
                setDirectBlocked(true);
                return;
            }
            const email = process.env.DEV_USER_EMAIL || localStorage.getItem("dev-user-email");
            if (email) {
                getAuthToken(email);
            } else {
                // No baked/remembered email -> ask via an in-app form (window.prompt is blocked
                // by office.js). The form's submit handler stores + calls getAuthToken.
                setEmailNeeded(true);
            }
        });
    }, []);

    const submitDevEmail = (e) => {
        if (e) e.preventDefault();
        const email = (emailInput || "").trim();
        if (!email) return;
        localStorage.setItem("dev-user-email", email);
        setEmailNeeded(false);
        getAuthToken(email);
    };

  useEffect(() => {
      if (username && !!authToken) {
      getData();
    }
  }, [username, authToken]);

  const criteriaChange = (criteria) => criteria === "Insured" || criteria === "Policy #" || criteria === "Submission #"
    ? "Type Insured/Policy"
    : criteria === "Producer #" || criteria === "Producer Name"
      ? "Type Producer"
      : "Type claim"

  const updateState = async (key, value) => {
    dismissAllToasts();
    switch (key) {
      case "comLocId":
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setCheckList([]);
        setDocumentType([]);
        setDocumentClass([]);
        const compId = profileDetails.filter((pd) => pd.compLocID == value)[0]?.companyID;
        if(value && compId) {
          setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, [key]: value, compLocId: value, compId, searchText: "", userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
          await getLocationSpecificInfo(value, compId);
        } else {
          setTaskPaneState((prev) => ({ 
            ...prev, 
            ...taskPaneInitailValue, 
            [key]: value, 
            compLocId: value, 
            compId, 
            searchText: "", 
            userGroupId: prev?.profileUserGroupId, 
            userGroup: prev?.userId,
            insuredForRecentPoliciesResults: [],
            criteriaItems: [],
            criteria: "",
            insuredId: "",
          }));
        }
        break;
      case "criteria":
        let searchText = taskPaneState?.searchText;
        let checklistItem = taskPaneState?.checklistItem;
        if (criteriaChange(taskPaneState.criteria) !== criteriaChange(value)) {
          setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          searchText = "";
          checklistItem = "";
          if(criteriaChange(value) === "Type Insured/Policy" && taskPaneState.comLocId) {
            getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId, value);
          }
        }
          setTaskPaneState((prev) => ({ ...prev, [key]: value, searchText, checklistItem}));
        break;
      case "insuredId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "searchText":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "userGroupId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value, userGroup: prev?.userId, taskQueue: "", taskType: "" }));
        break;
      case "docDescription":
      case "taskSubject":
        if(value?.length <= 60) {
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 60) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 60) }));
        }
        break;
      case "docNotes":
        if(value?.length <= 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 255) }));
        }
        break;
      case "checklistItem":
        const desctext = !!value? checkList.find(x => x.policyChecklistId == value)?.description || "" : "";
        const descTextTrim = (!!desctext && desctext?.length > 60) ? desctext.substring(0, 60) : desctext || "";
        setTaskPaneState((prev) => ({ 
          ...prev, 
          [key]: value, 
          docDescription: prev?.useChecklistItem? descTextTrim : prev?.docDescription || "",
          taskSubject: (prev?.sameAsDocDesc && prev?.useChecklistItem)? descTextTrim : prev?.taskSubject || ""
        }));
        break;
      case "useFileName":
        const subject = taskPaneState?.emailSubject;
        const subText = value? (!!subject && subject?.length > 60) ? subject.substring(0, 60) : subject || "" : ""
        setTaskPaneState((prev) => ({ ...prev, 
          [key]: value, 
          useChecklistItem: value? false: prev?.useChecklistItem,
          sameAsDocDesc: (!value && !prev?.useChecklistItem)? false : prev?.sameAsDocDesc,
          taskSubject: prev?.sameAsDocDesc? subText : prev?.taskSubject,
          docDescription: subText
        }));
        break;
      case "useChecklistItem":
        let checkItemText = "";
        if(checkList?.length && !!taskPaneState?.checklistItem) {
          const checkItemData = checkList.find(x => x.policyChecklistId == taskPaneState?.checklistItem)
          checkItemText = checkItemData?.description || "";
        }
        const descText = value? (!!checkItemText && checkItemText?.length > 60) ? checkItemText.substring(0, 60) : checkItemText || "" : "";
          setTaskPaneState((prev) => ({ ...prev, 
            [key]: value, 
            useFileName: value? false: prev?.useFileName,
            sameAsDocDesc: (!value && !prev?.useFileName)? false : prev?.sameAsDocDesc,
            taskSubject: prev?.sameAsDocDesc? descText : prev?.taskSubject,
            docDescription: descText
          }));
        break;
      default:
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
    }
  };
    const handleIndex = () => {
      dismissAllToasts();
      const maxSizeMB = 60;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      const totalSize = sessionStorage.getItem("fileSize")
      if (+totalSize > maxSizeBytes) {
        notify("error", "File is larger than allowed size");
        return;
      }

      // check date validation
      const referenceDate = new Date("1900-01-01");
      if (taskPaneState?.receivedDate) {
        const dateToCheck = new Date(taskPaneState?.receivedDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Received Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskStartDate) {
        const dateToCheck = new Date(taskPaneState?.taskStartDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Start Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskDueDate) {
        const dateToCheck = new Date(taskPaneState?.taskDueDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Due Date must be on or after 01/01/1900");
          return
        }
      }
      const hasSelectedUserGroup = userGroups.some((group) => String(group.userGroupID) === String(taskPaneState.userGroupId));
      const hasSelectedUser = user.some((person) => String(person.userID) === String(taskPaneState.userGroup));
      const hasSelectedQueue = queues.some((queue) => String(queue.imgCommonQueueID) === String(taskPaneState.taskQueue));
      if (taskPaneState.taskChecked && (!hasSelectedUserGroup || (!hasSelectedUser && !hasSelectedQueue))) {
        notify("error", "User Group and User or Queue are required to create a task.");
        return;
      }

        setLoading(true);
        callParentIndex();
  }
  const callParentIndex = async () => {
      try {
// Track a custom event
appInsights.trackEvent({ name: 'ButtonClicked', properties: { buttonName: 'SaveIndex', userID: taskPaneState?.userId } });
          const restId = sessionStorage.getItem('restId');
          const fromAddress = sessionStorage.getItem('fromAddress') || "unknown@example.com";
          const emailFromAddress = sessionStorage.getItem("emailFromAddress") || fromAddress;
     let SubmissionDetails = {
            SubmissionID: null,
            PolicyID: selectedItemDetailFromGrid?.policyID,
            DocType: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
            DocumentClassID: +taskPaneState.documentClass,
            WorkflowUserID: +taskPaneState?.userGroup,
            Destination: "",
            DestName: "",
            PipsProducer: {
              ProducerID: selectedItemDetailFromGrid?.ProducerID,
              IndexingUserID: taskPaneState?.userId
            },
            FileURL: null,
            Container: null,
            ExtractAttachments: false,
            OriginatingOfficeID: null,

            Sender: null,
            Recipient: null,
            CC: "",
            EmailHTML: null,
            FileContents: ""
          }
           const bodyData = {
                    subject: taskPaneState.taskSubject,
                    DocTypeId: taskPaneState?.documentType,
                    emailTime: "",
                    docTypeUsage: taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #" || taskPaneState?.criteria === "Submission #"? 1: 4,
                    description: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
                    dueDate: taskPaneState?.taskDueDate? new Date(taskPaneState?.taskDueDate): null,
                    pendDate: taskPaneState?.taskStartDate? new Date(taskPaneState?.taskStartDate): null,
                    modUserID: taskPaneState?.userId,
                    policyID: selectedItemDetailFromGrid?.policyID,
                    claimIncidentMasterID: 0,
                    providerID: 0,
                    producerID: 0,
                    destination: "",
                    destName: "",
                    workFlowUserID: +taskPaneState?.userGroup,
                    documentClassID: +taskPaneState?.documentClass,
                    compLocID: +taskPaneState?.comLocId,
                    indexNote: taskPaneState?.docNotes,
                    documentNote: taskPaneState?.docNotes,
                    note: taskPaneState?.taskNote,
                    task: taskPaneState?.taskChecked,
                    receivedDate: taskPaneState?.receivedDate? new Date(taskPaneState?.receivedDate) : null,
                    priorityID: +taskPaneState?.taskPriority,
                    taskTypeID: +taskPaneState?.taskType,
                    userGroupID: +taskPaneState?.userGroupId,
                    vendorID: 0,
                    campaignID: 0,
                    transSummaryID: 0,
                    docType: +taskPaneState?.documentType,
                    policyChecklistID: +taskPaneState?.checklistItem,
                    chkTask: !!taskPaneState?.taskChecked,
                    chkUseFileName: !!taskPaneState?.useFileName,
                    chkQuoteSentToProducer: !!taskPaneState?.chkQuoteSentToProducer,
                    intFileID: 0,
                    userID: taskPaneState?.userId,
                    queueID: +taskPaneState?.taskQueue,
                    fileID: 0,
                    workFlowUser: "",
                    workFlowDestination: "",
                    hostType: "Outlook",
                    fromAddress: fromAddress,
                    emailFromAddress,
                    actionType: actionType === "sendMailAndOpenTaskPane" ? "compose" : "read",
                    ewsItemId: restId,
                    submissionDetails: {
                      ...SubmissionDetails
                    }
       };
        if(!!sessionStorage.getItem("sharedOwner")) { 
          Office.context.ui.messageParent(JSON.stringify({
            ...bodyData,
            isShared: true,
            sendIndexApi: true,
            authToken: sessionStorage.getItem("auth-token"),
            graphToken: sessionStorage.getItem("graph_token"),
          }));
          appInsights.trackDependencyData({
            target: process.env.BASE_URL,
            name: "Outlook_Saveindex_Payload",
            properties: { isShared: true, ...bodyData }
          });
        } else if (actionType === "sendMailAndOpenTaskPane") {
            setTimeout(() => {
                finalizeDownload(bodyData);
            }, 1000);
        } else {
            finalizeDownload(bodyData);
        }
   } catch (e) {
        console.log(e);
        setLoading(false);
        notify("error", "Failed to send indexing request");
   }
  }
    
    async function finalizeDownload(data) {
        
        try {
            const subject = sessionStorage.getItem("mailsubject") || "No Subject"

            //const files = new File([blob], `${subject}`, { type: blob.type });
            const bodyData = {
                ...data,
                FileName: `${subject}.eml`,
                FileType: "message/rfc822",
                submissionDetails: {
                    ...data.submissionDetails,
                    FileName: `${subject}.eml`,
                    FileType: "message/rfc822",
                }
            };
            const formData = new FormData();
            formData.append("file", null);
            formData.append("bodyData", JSON.stringify(bodyData));

            const fullUrl = `/saveindex/InsertImgInfo`;

            // Authorization + userId are injected by the auth interceptor (authInterceptor.js),
            // which reads sessionStorage at request-time (see onRequestFulfilled). Setting
            // Authorization here would shadow it and prevent token refresh on expiry.
            const settings = {
                method: 'POST',
                headers: {
                    'X-Graph-Token': sessionStorage.getItem('graph_token') || '',
                },
                body: formData
            };
            const startTime = Date.now();
            // const uploadResponse = await fetch(fullUrl, settings);
            axios.post(fullUrl, formData, {
                timeout: 40000,
                headers: {
                    'X-Graph-Token': sessionStorage.getItem('graph_token') || '',
                }
            }).then(() => {
          // Track a dependency (e.g., Graph API call)
          const duration = Date.now() - startTime;
            appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Outlook_Saveindex_Payload",
              dependencyTypeName: "HTTPS",
              success: true,
              responseCode: 200,
              properties: bodyData,
              duration
            });
                if (actionType === "sendMailAndOpenTaskPane") Office.context.ui.messageParent("sendMail");
                else handleModel();
            }).catch((e) => {
                console.log(e);
                const errorText = e?.response?.data;
                const duration = Date.now() - startTime;
                 appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Outlook_Saveindex_Payload",
              dependencyTypeName: "HTTPS",
              success: false,
              responseCode: e?.status || 500,
              properties: {
                bodyData: bodyData,
                error: e
              },
              duration
            });
                setLoading(false);
                if (e.code === 'ECONNABORTED') {
                    console.error("Something went wrong, please try again.");
                    notify("error", "Something went wrong, please try again.");
                } else {
                    if (e.status === 500 || e.status === 502) {
                        notify("error", errorText);
                    } else {
                        notify("error", "Failed to index");
                    }
                }
            })
        } catch (error) {
            console.log(error);
            // notify("error", "Failed to index");
            setLoading(false);
        }
    }


  const handleModel = () => {
      setLoading(false);
      Office.context.ui.messageParent(JSON.stringify({ close: true }));
  }

    useEffect(() => {
        Office.onReady().then(() => {
        // Signal the parent command to fetch the SSO token. Both read + compose use
        // messageParent: an Office dialog has ISOLATED localStorage (not shared with the
        // parent window), so the old read-path localStorage signal never reached the
        // command and the SSO token was never sent back. The parent's
        // DialogMessageReceived handler (commands.js) processes "requestToken".
        Office.context?.ui?.messageParent?.("requestToken");
        Office.context?.ui?.addHandlerAsync?.(
          Office.EventType.DialogParentMessageReceived,
          (arg) => {
            if (!arg) return;
            if (arg.message === "Failed") {
              setLoading(false);
              notify("error", "Failed to index");

                 appInsights.trackDependencyData({
                   target: process.env.BASE_URL,
                   name: "Outlook_Saveindex_Payload",
                   dependencyTypeName: "HTTPS",
                   success: false,
                   responseCode: 500,
                   properties: {
                     error: "Failed to index"
                   }
                 });
              return;
            } else if (arg.message === "ok") {
              // setLoading(false);
              notify("success", "Indexing successful!");
              handleModel();
              return;
            }

            let mes;
            try { mes = JSON.parse(arg.message); } catch (_e) { return; }
            if (!mes || typeof mes !== "object") return;
             if (!!mes?.token && mes?.itemID) {
              sessionStorage.setItem("mailsubject", mes?.mailsubject || "");
              sessionStorage.setItem("itemID", mes?.itemID || "");
              sessionStorage.setItem("restId", mes?.restId || "");
              sessionStorage.setItem("access-token", mes?.token);
              sessionStorage.setItem("fileSize", mes?.fileSize || 0);
              sessionStorage.setItem("sharedOwner", mes?.sharedOwner || "");
              sessionStorage.setItem("emailFromAddress", mes?.from || "");
              setAccessToken(mes?.token);
            }
            if (!!mes?.Failed && mes?.errorText) {
              notify("error", mes?.errorText);
              setLoading(false);
              appInsights.trackDependencyData({
                target: process.env.BASE_URL,
                name: "Outlook_Saveindex_Payload",
                dependencyTypeName: "HTTPS",
                success: false,
                responseCode: (mes?.errorText == "File is larger than allowed size")? 400 : 500,
                properties: {
                  error: mes?.errorText
                }
              });
            }
          }
        );
      });
    }, []);

    const styles = useStyles();
    
    Office.onReady(() => {
    appInsights.trackPageView({ name: "Taskpane Loaded" });
  });

  const clearToaster = () => {
    dismissAllToasts();
    notify("progress");
  }

  useEffect(() => {
    dismissAllToasts();
  }, [selectedGridItem])
  
  if (directBlocked) {
    return (
      <div className={styles.root}>
        <div className="page-bg">
          <div className="page-layout relative w-full mx-auto text-black z-10">
            <div className="main-container p-4 mt-1 text-center">
              <h2 className="h2-text text-base font-semibold text-black-700 mb-2">
                Please open this add-in inside Outlook
              </h2>
              <p className="text-sm text-gray-600">
                Sign-in to PIPS requires the Office host. Open the add-in from Outlook to continue.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (emailNeeded) {
    return (
      <div className={styles.root}>
        <div className="page-bg">
          <div className="page-layout relative w-full mx-auto text-black z-10">
            <form className="main-container p-4 mt-1" onSubmit={submitDevEmail}>
              <h2 className="h2-text text-base font-semibold text-black-700 mb-2">Dev mode sign-in</h2>
              <p className="text-sm text-gray-600 mb-2">Enter your email to load PIPS data:</p>
              <input
                type="email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="you@bbins.com"
                className="input-layout rounded py-1 px-2 text-sm text-gray-700 w-full mb-2"
              />
              <button type="submit" className="btn-com" disabled={!emailInput.trim()}>
                Continue
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {loading && <Loader />}
      <div className="page-bg">
        <div className="page-layout relative w-full mx-auto text-black z-10">
          {Toaster}
          <div className="main-container p-1 mt-1">
            <div className="card-layout p-2 shadow-md">
              <SearchCriteria
                              updateState={updateState}
                              clearToaster={clearToaster}
                              actionType={actionType }
                              authToken={authToken}
                              authStatus={authStatus}
                              profileStatus={profileStatus}
                              locationStatus={locationStatus}
                              onRetryBootstrap={retryBootstrap}
              />
              <RecentList
                updateState={updateState}
              />
            </div>
            <IndexingForm updateState={updateState} handleIndex={handleIndex} handleModel={handleModel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
